import React from "react";
import tikitColoredIcon from "../../images/tikit-logo-colored.png";
import ticketIcon from "../../images/ticket.png";
import { Text } from "@fluentui/react-northstar";
import { threedigitized } from "./ticketHelper";

type PrintHeaderProps = {
  ticketId: number;
  status?: string;
}

export const PrintHeader: React.FC<PrintHeaderProps> = ({ticketId, status}) => {
  return (
    <div className="flex justify-between w-full border-b-1">
        <div>
            <img src={tikitColoredIcon} alt="Tikit Logo" width="57px" />
        </div>
        <div>
            <Text size="medium" weight="semibold" className="ml-2 print-text-color">
                Ticket Transcript 
            </Text>
        </div>
        <div className="flex items-center print-text-color">
          <img src={ticketIcon} alt="Tikit Logo" width="16px" />
          <Text className="mx-1" weight="semibold"># {threedigitized(ticketId)}</Text> 
          <Text className="mx-1">Status:</Text> 
          <Text className="mx-1" weight="semibold">{ status ?? "-"}</Text>
        </div>
    </div>
  );
};